export const locale_es = {
    "lang": "es",
    "data": {        
        "HELLO-WORLD": {
                NAME: "Hola Mundo"
            },
        },
    
}